import {
  Box,
  Divider,
  ListItemText,
  Accordion as MUIAccordion,
  AccordionDetails as MUIAccordionDetails,
  AccordionSummary as MUIAccordionSummary,
  Menu,
  MenuItem,
  Paper,
  Typography,
  styled,
} from '@mui/material'
import { FastField as FormikFastField } from 'formik'

export const Wrapper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: '.8rem',
}))

export const Title = styled(Typography)(() => ({}))

Title.defaultProps = {
  variant: 'h4',
}

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
}))

Subtitle.defaultProps = {
  variant: 'h6',
}

export const FormWrapper = styled(Box)(({ theme }) => ({
  padding: [theme.spacing(4), 0].join(' '),
}))

export const FormAreaTitle = styled(Typography)(({ theme }) => ({
  margin: [theme.spacing(4), 0].join(' '),
  color: theme.palette.secondary.light,
}))

FormAreaTitle.defaultProps = {
  variant: 'h5',
}

export const AccordionsWrapper = styled(Box)(({ theme }) => ({
  borderRadius: '0.8rem',
  overflow: 'hidden',
  marginBottom: theme.spacing(4),
  width: `calc(100% + ${theme.spacing(12)})`,
  marginLeft: `-${theme.spacing(6)}`,
}))

export const Accordion = styled(MUIAccordion)<{
  hide?: boolean
}>(({ hide, theme }) => ({
  display: hide ? 'none' : 'block',
  width: '100%',
  padding: [theme.spacing(1), theme.spacing(2)].join(' '),
  // minWidth: '100%',
  borderRadius: theme.shape.borderRadius,

  backgroundColor: 'transparent',

  '&:before': {
    backgroundColor: 'transparent',
  },
  '&:not(:only-child)': {
    borderTop: '1px solid #ccc',
    '&:first-of-type': {
      borderTop: '1px solid transparent',
    },
  },
}))

export const AccordionSummary = styled(MUIAccordionSummary)(() => ({}))
export const AccordionDetails = styled(MUIAccordionDetails)(() => ({}))

export const AccordionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.light,
  width: '44%',
  flexShrink: 0,
}))
AccordionTitle.defaultProps = {
  variant: 'h5',
}

export const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}))

export const SectionDivider = styled(Divider)(() => ({}))

export const InputGroup = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: theme.spacing(4),
}))

export const FastField = styled(FormikFastField)(() => ({ flex: 1 }))

export const FormButtonWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  width: '100%',
  display: 'flex',
  justifyContent: '',
}))

export const CreateAuditMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    border: '1px solid rgba(0,0,0,.25)',
    borderRadius: '.5rem',
    boxShadow:
      'rgb(255 255 255 / 90%) 0rem 0rem 0.0625rem 0.0625rem inset, rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem',
  },
  '& .MuiPaper-root > .MuiList-root': {
    padding: theme.spacing(2),
  },
}))
export const AuditMenuItem = styled(MenuItem)(() => ({
  borderRadius: '.5rem',
}))
export const AuditMenuText = styled(ListItemText)(() => ({
  fontSize: '1rem',
  color: 'black',
}))
